import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PostZone, PutZone, Zone } from 'src/app/interfaces/api/zone';
import { RequestService } from '../../core/request.service';
import { WebSocketService } from '../../core/web-socket.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class ZoneService {

  collection = "Zone";
  collectionPath = "zones";
  zones: Zone[] = [];

  constructor(
    public http: HttpClient,
    private request: RequestService,
    private socket: WebSocketService,
  ) { }

  //---GET---//

  getZones(query: QueryParams = {}): Observable<Zone[]> {
    return concat(
      this.request.getCollection(this.collection, this.collectionPath, query),
      this.socket.getUpdate(this.collection)
    )
  }

  getLastZone(query: QueryParams = {}): Observable<Zone[]> {
    return this.request.getCollection(this.collection, this.collectionPath, query, "last").pipe(
      tap((result: any) => {
        if (result) {
          //recup last zone
        }
      })
    )
  }
  
  getZone(id: string): Observable<Zone> {
    return this.request.getItem(this.collection, this.collectionPath, id)
  }

  //---POST---//

  addZone(zone: PostZone): Observable<Zone> {
    return this.request.postItem(this.collection, this.collectionPath, zone);
  }

  addZones(zones: PostZone[]): Observable<Zone[]> {
    // return this.http.post(this.API_URL + '/zones/many', zones);
    return this.request.postItems(this.collection, this.collectionPath, zones);
  }

  //---PUT---//

  updateZone(zone: PutZone): Observable<any> {
    return this.request.setProjectData(this.collection, this.collectionPath, zone);
  }

  //---DELETE---//

  removeZone(id: string): Observable<any> {
    
    return this.request.deleteItem(this.collection, this.collectionPath, id);
  }

  removeZones(query: QueryParams = {}): Observable<any> {
    return this.request.deleteManyItems(this.collection, this.collectionPath, query);
  }

}
